/* ============================================================
   ORA INHALE — Fiche produit
   ============================================================ */

(function () {
  'use strict';

  /* ── Galerie ─────────────────────────────────────────────── */
  var imgs    = document.querySelectorAll('.ora-pdp__gallery-img');
  var thumbs  = document.querySelectorAll('.ora-pdp__thumb');
  var prevBtn = document.getElementById('ora-pdp-prev');
  var nextBtn = document.getElementById('ora-pdp-next');
  var counter = document.getElementById('ora-pdp-counter');
  var current = 0;
  var total   = imgs.length;

  function pad(n) { return String(n).padStart(2, '0'); }

  function goTo(index) {
    if (total === 0) return;
    current = (index + total) % total;

    imgs.forEach(function (img, i) {
      img.classList.toggle('is-active', i === current);
      if (img.tagName === 'VIDEO') {
        if (i === current) {
          var p = img.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        } else if (typeof img.pause === 'function') {
          img.pause();
        }
      }
    });

    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('is-active', i === current);
    });

    if (counter) {
      counter.textContent = pad(current + 1) + ' / ' + pad(total);
    }
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goTo(parseInt(thumb.dataset.index, 10));
    });
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  /* Lecture auto si la première slide est une vidéo */
  if (imgs[current] && imgs[current].tagName === 'VIDEO') {
    var firstPlay = imgs[current].play();
    if (firstPlay && typeof firstPlay.catch === 'function') { firstPlay.catch(function () {}); }
  }

  /* Swipe mobile sur la galerie principale */
  var mainGallery = document.getElementById('ora-pdp-main');
  if (mainGallery) {
    var startX = 0;
    mainGallery.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    mainGallery.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 40) goTo(delta < 0 ? current + 1 : current - 1);
    });
  }

  /* ── Sélecteur de quantité ───────────────────────────────── */
  var qtyVal   = document.getElementById('ora-pdp-qty-val');
  var qtyInput = document.getElementById('ora-pdp-quantity');
  var qtyMinus = document.getElementById('ora-pdp-qty-minus');
  var qtyPlus  = document.getElementById('ora-pdp-qty-plus');
  var qty = 1;

  function setQty(n) {
    qty = Math.max(1, n);
    if (qtyVal)   qtyVal.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  }

  if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(qty - 1); });
  if (qtyPlus)  qtyPlus.addEventListener('click', function ()  { setQty(qty + 1); });

  /* ── Sélecteur de variantes ──────────────────────────────── */
  var variantBtns  = document.querySelectorAll('.ora-pdp__variant-btn');
  var variantInput = document.getElementById('ora-pdp-variant-id');
  var priceEl      = document.getElementById('ora-pdp-price');
  var stickyBtn    = document.getElementById('ora-pdp-sticky-btn');

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      variantBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (variantInput) variantInput.value = btn.dataset.variantId;
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
      if (stickyBtn && btn.dataset.price) {
        stickyBtn.textContent = 'Ajouter au panier — ' + btn.dataset.price;
      }
    });
  });

  /* ── ATC AJAX ────────────────────────────────────────────── */
  var form   = document.getElementById('ora-pdp-form');
  var atcBtn = document.getElementById('ora-pdp-atc');

  if (form && atcBtn) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var varId = variantInput ? variantInput.value : null;
      if (!varId || atcBtn.disabled || atcBtn.classList.contains('is-adding')) return;

      var origText = atcBtn.textContent.trim();
      atcBtn.textContent = '…';
      atcBtn.disabled = true;
      atcBtn.classList.add('is-adding');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(varId), quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        atcBtn.classList.remove('is-adding');
        atcBtn.classList.add('is-added');
        atcBtn.textContent = '✓ Ajouté !';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('.ora-header__cart-count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        });
        document.dispatchEvent(new CustomEvent('ora:cart:open'));
        setTimeout(function () {
          atcBtn.classList.remove('is-added');
          atcBtn.textContent = origText;
          atcBtn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        atcBtn.classList.remove('is-adding');
        atcBtn.textContent = origText;
        atcBtn.disabled = false;
      });
    });
  }

  /* ── Acheter maintenant : ajoute au panier puis va au paiement ── */
  var buyNowBtn = document.getElementById('ora-pdp-buy-now');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function (e) {
      e.preventDefault();

      var varId = variantInput ? variantInput.value : null;
      if (!varId || buyNowBtn.classList.contains('is-loading')) return;

      buyNowBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(varId), quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { buyNowBtn.classList.remove('is-loading'); });
    });
  }

  /* ── Sticky CTA (déclenché par le bouton sticky) ─────────── */
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  /* ── IntersectionObserver → afficher sticky ─────────────── */
  var sticky = document.getElementById('ora-pdp-sticky');

  if (sticky && atcBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.5 });
    observer.observe(atcBtn);
  }

  /* ── Accordéons ──────────────────────────────────────────── */
  var accordion = document.getElementById('ora-pdp-accordion');
  if (accordion) {
    accordion.querySelectorAll('.ora-pdp__accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ora-pdp__accordion-item');
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* ── Produits similaires via API recommandations ────────── */
  var similarSection = document.getElementById('ora-pdp-similar');
  var similarGrid    = document.getElementById('ora-pdp-similar-grid');

  if (similarSection && similarGrid) {
    var productId = similarSection.dataset.productId;

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products;
        if (!products || products.length === 0) {
          similarSection.style.display = 'none';
          return;
        }

        var html = '';
        products.forEach(function (p) {
          var imgTag = p.featured_image
            ? '<img src="' + p.featured_image + '" alt="' + (p.title || '') + '" loading="lazy">'
            : '';
          var price = (p.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

          html += '<a href="' + p.url + '" class="ora-pdp__similar-card">'
            + '  <div class="ora-pdp__similar-card-media">' + imgTag + '</div>'
            + '  <div class="ora-pdp__similar-card-info">'
            + '    <p class="ora-pdp__similar-card-name">' + (p.title || '') + '</p>'
            + '    <p class="ora-pdp__similar-card-price">' + price + '</p>'
            + '  </div>'
            + '</a>';
        });

        similarGrid.innerHTML = html;
      })
      .catch(function () {
        similarSection.style.display = 'none';
      });
  }

})();
